export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7441.c9b5e6ec.jpg";